import { } from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

import { AppAction } from '../../../../store';

export interface ReminderNotificationsPopupState {
  notificationsError: null
};

const initialState: ReminderNotificationsPopupState = {
  notificationsError: null
};

const markNotificationAsReadStart = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: null,
  });
};

const markNotificationAsReadSuccess = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: null,
  });
};

const markNotificationAsReadFail = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: action.error,
  });
};

const markAsRemindLaterStart = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: null,
  });
};

const markAsRemindLaterSuccess = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: null,
  });
};

const markAsRemindLaterFail = (state: ReminderNotificationsPopupState, action: AppAction<null>) => {
  return updateObject(state, {
    notificationsError: action.error,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.MARK_NOTIFICATION_AS_READ_START:
      return markNotificationAsReadStart(state, action as AppAction<null>);
    case actionTypes.MARK_NOTIFICATION_AS_READ_SUCCESS:
      return markNotificationAsReadSuccess(state, action as AppAction<null>);
    case actionTypes.MARK_NOTIFICATION_AS_READ_FAIL:
      return markNotificationAsReadFail(state, action as AppAction<null>);

    case actionTypes.MARK_AS_REMIND_LATER_START:
      return markAsRemindLaterStart(state, action as AppAction<null>);
    case actionTypes.MARK_AS_REMIND_LATER_SUCCESS:
      return markAsRemindLaterSuccess(state, action as AppAction<null>);
    case actionTypes.MARK_AS_REMIND_LATER_FAIL:
      return markAsRemindLaterFail(state, action as AppAction<null>);

    default:
      return state;
  }
};

export default reducer;
